import { useAolStore } from '../../../context/AolContext';
import { Wrapper } from './CargoTempDateListComponent.style';
import AolFilterHeaderComponent from '../../aol/aol-filter-header/AolFilterHeader';
import { CargoTemperatureLogDate } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureLogDate';
import useCargoTempLogApi from '../../../api/cargo-temp-log/useCargoTempLogApi';
import { useVesselStore } from '../../../context/VesselContext';
import { useCargoTempLogStore } from '../../../context/CargoTempLogContext';
import { useEffect } from 'react';
import { CargoTemperatureConfig } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureConfig';
import CargoTempDateListItem from './CargoTempDateListItem';
import { formatAolUrlDate, getAolDateFromUrlFormat } from '../../../utils/aol/aolDateUtils';
import queryParamsUtils from '../../../utils/queryParamsUtils';
import { InfoText } from '../../shared/info-text/InfoText.style';
import useApiLoaderHelper from '../../../utils/useApiLoaderHelper';
import { formatDateTime, DateTimeFormat } from 'odfjell-date-time-utils/dateTimeFormatter';
import { isDateAfter, isDateSame } from 'odfjell-date-time-utils/dateTimeUtils';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import useAppFeature from 'src/app/useAppFeature';

type Props = {
    populatedCargoTempLogDates: CargoTemperatureLogDate[];
    cargoTemperatureConfigs: CargoTemperatureConfig[];
};

const CargoTempListComponent: React.FC<Props> = (props: Props) => {
    const { getCargoTemperatureLog } = useCargoTempLogApi();
    const { setSelectedCargoTempDate, selectedCargoTempDate } = useCargoTempLogStore();
    const { selectedVessel } = useVesselStore();
    const { setAolFilter, aolFilter } = useAolStore();
    const { getCargoTempLogDates } = useCargoTempLogApi();
    const { setQueryParamCargoTempLog } = queryParamsUtils();
    const { isLoadingType } = useApiLoaderHelper();
    const { queryParamUpdate, getQueryParamValueFromUrl } = useQueryParamsHandler();
    const { getAppFeatureFromDateForVessel } = useAppFeature();

    useEffect(() => {
        if (!queryParamUpdate || !props.populatedCargoTempLogDates || props.populatedCargoTempLogDates.length === 0) return;
        selectCargoTempLogDateFromQuery();
    }, [queryParamUpdate, props.populatedCargoTempLogDates]);

    const selectCargoTempLogDateFromQuery = () => {
        const aolDateStr = getQueryParamValueFromUrl('aolDate');

        if (aolDateStr) {
            const aolDate = getAolDateFromUrlFormat(aolDateStr);
            setSelectedCargoTempDate(aolDate);
        }
    };

    const onSelectCargoTempDate = (selectedDate: Date) => {
        if (selectedDate && selectedVessel && selectedDate < new Date()) {
            const aolDate = formatAolUrlDate(selectedDate).toString();
            const currentAolDate = getQueryParamValueFromUrl('aolDate');
            if (aolDate === currentAolDate) return;
            getCargoTemperatureLog(selectedVessel.imoNumber, formatAolUrlDate(selectedDate));
            setQueryParamCargoTempLog(aolDate);
        }
    };

    const isSelectedListItem = (date: Date) => {
        if (isDateSame(selectedCargoTempDate, date, 'day')) {
            return true;
        }
    };

    const onSelectCalendarDate = (fromDate: Date, toDate: Date) => {
        setSelectedCargoTempDate(null);
        const stowageIntegrationFromDate = getAppFeatureFromDateForVessel({
            featureEnum: AppFeatureEnum.StowageIntegration,
            imoNumber: selectedVessel.imoNumber,
        });
        getCargoTempLogDates(
            selectedVessel!.imoNumber,
            formatAolUrlDate(fromDate),
            formatAolUrlDate(toDate),
            formatAolUrlDate(stowageIntegrationFromDate),
            false
        );
        sessionStorage.setItem('userChangedFilter', 'true');
        setAolFilter({ fromDate, toDate, isDefault: false });
    };

    return (
        <>
            <Wrapper>
                <AolFilterHeaderComponent onChange={onSelectCalendarDate} page={'cargoTemp'}></AolFilterHeaderComponent>
                <div className="aol-list">
                    {props.populatedCargoTempLogDates && props.populatedCargoTempLogDates.length > 0 && (
                        <>
                            {props.populatedCargoTempLogDates.map((cargoTempLogDate) => (
                                <CargoTempDateListItem
                                    key={'cargo_list_date_item ' + formatDateTime(cargoTempLogDate.logDate, DateTimeFormat.queryFormats.dateOnly)}
                                    populatedCargoTempLogDates={props.populatedCargoTempLogDates}
                                    cargoTemperatureConfigs={props.cargoTemperatureConfigs}
                                    cargoTempLogDate={cargoTempLogDate}
                                    onSelectCargoTempDate={onSelectCargoTempDate}
                                    isSelectedListItem={isSelectedListItem}
                                />
                            ))}
                        </>
                    )}
                    {!isLoadingType('cargoTempLogDates') &&
                        !isLoadingType('cargoTemperatureLogs') &&
                        isDateAfter(aolFilter?.fromDate, new Date()) && (
                            <InfoText>Future dates selected in date filter. Select current date or earlier.</InfoText>
                        )}
                    {!isLoadingType('cargoTempLogDates') &&
                        !isLoadingType('cargoTemperatureLogs') &&
                        (!props.populatedCargoTempLogDates || props.populatedCargoTempLogDates.length === 0) && (
                            <InfoText>No cargo log dates for period.</InfoText>
                        )}
                </div>
            </Wrapper>
        </>
    );
};

export default CargoTempListComponent;
